import { remoteSetCourseUserOptions } from "../../queries/courses";
import Dialog from "rc-dialog";
import React from "react";

const setUserOption = async (option = "", items, contextData) => {
    // insured | employer_specific
    const courseUUID = contextData?.courseDetail?.uuid;
    const courseStudents = contextData?.courseDetail?.students;
    // const courseStudentOptions = contextData?.courseDetail?.student_options || [];

    const studentOptions = courseStudents.reduce((options, student) => {
        // The provided items are the students that are selected in the overview.
        // Only these students should be modified, the rest should be left alone.
        if (!items.includes(student.uuid)) {
            return options;
        }
        // If we always use true as a value, we cannot remove the option.
        // todo: By checking the current options for the student we can toggle the option instead of always setting it to true.
        // todo: Do we want to toggle or always set to true?
        // const currentOptions = courseStudentOptions.find(option => option.user === student.uuid);
        // const value = currentOptions ? !currentOptions[option] : true;
        const value = true;
        options.push({
            userUUID: student.uuid,
            name: option,
            value
        });
        return options;
    }, []);
    if (!studentOptions.length) {
        return Promise.resolve();
    }

    return await remoteSetCourseUserOptions(courseUUID, studentOptions);
};

export function SetStudentsBusinessSpecificModal({ items, contextData, addGlobalMessage, close, onSuccess }) {
    const footerButtons = [
        <button
            type="button"
            className="btn btn-light"
            key="no"
            onClick={() => {
                close();
            }}
        >
            Nee, annuleer deze keuze
        </button>,
        <button
            type="button"
            className="btn btn-primary"
            key="yes"
            onClick={async () => {
                await setUserOption("employer_specific", items, contextData);

                addGlobalMessage({
                    title: "De geselecteerde cursisten zijn succesvol op bedrijfsspecifiek gezet."
                });
                if (typeof onSuccess === "function") {
                    onSuccess();
                }
                close();
            }}
        >
            Koppel bedrijfsspecifiek
        </button>
    ];
    return (
        <Dialog title={"Bedrijfsspecifieke competentie(s)"} onClose={() => close()} visible={true} animation="fade" footer={footerButtons}>
            <p className={"paragraph"}>
                Ik wil deze {items?.length > 1 ? items.length : ""} cursist{items?.length !== 1 ? "en" : ""} voorzien van een bedrijfsspecifieke aantekening.
            </p>
        </Dialog>
    );
}
export function InsureStudentsModal({ items, contextData, addGlobalMessage, close, onSuccess }) {
    const footerButtons = [
        <button
            type="button"
            className="btn btn-light"
            key="no"
            onClick={() => {
                close();
            }}
        >
            Nee, verzeker cursisten niet
        </button>,
        <button
            type="button"
            className="btn btn-primary"
            key="yes"
            onClick={async () => {
                await setUserOption("insured", items, contextData);
                addGlobalMessage({
                    title: `De geselecteerde cursisten zijn succesvol verzekerd.`
                });
                if (typeof onSuccess === "function") {
                    onSuccess();
                }
                close();
            }}
        >
            Verzeker cursisten
        </button>
    ];
    return (
        <Dialog title={"Verzeker cursisten"} onClose={() => close()} visible={true} animation="fade" footer={footerButtons}>
            <p className={"paragraph"}>
                Ik wil deze {items?.length > 1 ? items.length : ""} cursist{items?.length !== 1 ? "en" : ""} verzekeren voor deze cursus.
            </p>
        </Dialog>
    );
}
